import { X, Factory, Shield, Truck, Clock } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const FACTORY_IMAGES = [
  {
    src: "https://customer-assets.emergentagent.com/job_97f513fe-a3cb-403b-b669-1693d7f5acab/artifacts/xc04hkqg_Factory%201.png",
    label: "Production Floor",
    desc: "German-standard edge banding & assembly"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_97f513fe-a3cb-403b-b669-1693d7f5acab/artifacts/7lo3zof8_Factory%202.png",
    label: "State-of-Art Facility",
    desc: "Modern machinery & quality control"
  },
  {
    src: "https://customer-assets.emergentagent.com/job_97f513fe-a3cb-403b-b669-1693d7f5acab/artifacts/w54p034i_image.png",
    label: "Quality Packing",
    desc: "Secure packaging for safe delivery"
  }
];

const TRUST_POINTS = [
  { icon: Factory, text: "Own Manufacturing Unit" },
  { icon: Shield, text: "German-Standard Technology" },
  { icon: Clock, text: "Rapid Scalability" },
  { icon: Truck, text: "Direct from Factory" }
];

export function ProductionModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[100] flex items-center justify-center p-4" onClick={onClose} data-testid="production-modal-overlay">
      <div 
        className="bg-white max-w-3xl w-full max-h-[85vh] overflow-y-auto rounded-sm shadow-2xl"
        onClick={(e) => e.stopPropagation()}
        data-testid="production-modal"
      >
        {/* Header */}
        <div className="sticky top-0 bg-white border-b border-gray-100 px-6 py-4 flex justify-between items-center z-10">
          <div>
            <p className="text-[#c5a059] text-[10px] font-bold tracking-[0.2em] uppercase">Our Production</p>
            <h3 className="text-lg font-bold text-[#1a1a1a]" >
              From Concept to Installation
            </h3>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-testid="production-modal-close">
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        <div className="p-6">
          {/* Brand Statement */}
          <div className="bg-[#1e2330] text-white p-6 mb-6">
            <p className="text-[#c5a059] text-xs font-medium tracking-wider mb-2">
              A brand of Ezeefit Modular Furniture Pvt. Ltd.
            </p>
            <p className="text-gray-300 text-sm leading-relaxed">
              Delivering scalable office furniture solutions for growing corporates since 2014. 
              From concept to installation — complete workspace execution under one roof.
            </p>
          </div>

          {/* Factory Images Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-6">
            {FACTORY_IMAGES.map((img, idx) => (
              <div key={idx} className="relative overflow-hidden group">
                <img
                  src={img.src}
                  alt={img.label}
                  className="w-full h-48 object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                  width={400}
                  height={300}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1a1a1a]/80 to-transparent" />
                <div className="absolute bottom-3 left-3 right-3">
                  <p className="text-white text-sm font-bold">{img.label}</p>
                  <p className="text-gray-300 text-xs">{img.desc}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Trust Points */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
            {TRUST_POINTS.map((point, idx) => (
              <div key={idx} className="flex flex-col items-center text-center p-4 bg-[#F8F6F1] border border-gray-100">
                <point.icon className="w-6 h-6 text-[#c5a059] mb-2" />
                <p className="text-xs font-semibold text-[#1a1a1a]">{point.text}</p>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="flex flex-wrap gap-3">
            <Link to="/bulk-inquiry" onClick={onClose}>
              <Button className="bg-[#c5a059] hover:bg-[#b8934d] text-white rounded-none px-6 py-4 text-xs tracking-[0.15em] font-bold">
                GET FACTORY DIRECT QUOTE
              </Button>
            </Link>
            <Link to="/about" onClick={onClose}>
              <Button variant="outline" className="border-2 border-[#1a1a1a] text-[#1a1a1a] hover:bg-[#1a1a1a] hover:text-white rounded-none px-6 py-4 text-xs tracking-[0.15em] font-bold bg-transparent">
                LEARN MORE
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
